import { Box, Typography } from '@shared/ui';
import { AlertIcon } from '@shared/ui/icons';
import { useSelector } from 'react-redux';

/**
 * Error card replacing the InfoPane body when the patient fetch fails.
 * `onRetry` re-fires the same fetch the legacy LoadingErrorWidget did.
 */
const ErrorBody = ({ onRetry }) => {
  const { infoPane } = useSelector(state => state.i18n);
  return (
    <Box
      sx={{
        margin: '16px 20px',
        padding: '16px',
        background: 'var(--qhs-error-light, #fdecec)',
        border: '1px solid rgba(220, 18, 18, 0.18)',
        borderRadius: 8,
        display: 'flex',
        gap: '10px',
        alignItems: 'flex-start',
      }}
    >
      <AlertIcon
        style={{ color: 'var(--qhs-error, #dc1212)', width: 18, height: 18, flexShrink: 0 }}
      />
      <Box>
        <Typography
          sx={{ fontFamily: 'var(--qhs-font-head)', fontSize: 13, fontWeight: 700, color: '#7a0c0c', mb: 0.25 }}
        >
          {infoPane.errorTitle}
        </Typography>
        <button
          type='button'
          onClick={onRetry}
          style={{
            background: 'transparent',
            border: 'none',
            padding: 0,
            fontSize: 12,
            fontWeight: 600,
            color: 'var(--qhs-error, #dc1212)',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          {infoPane.errorRetry}
        </button>
      </Box>
    </Box>
  );
};

export default ErrorBody;
